/**
 * Readiness score ring (C4 flagship number). Pure SVG, self-contained, tokened.
 * Score band drives the accent so severity is not hue-alone — a grade label
 * always accompanies it.
 */
// Kept module-local so this component file only exports a component
// (react-refresh/only-export-components). Score→band logic lives here.
type ScoreBand = 'pass' | 'warn' | 'critical';

function bandForScore(score: number): ScoreBand {
  if (score >= 80) return 'pass';
  if (score >= 50) return 'warn';
  return 'critical';
}

const BAND_COLOR: Record<ScoreBand, string> = {
  pass: 'var(--green)',
  warn: 'var(--orange)',
  critical: 'var(--red)',
};

export function ScoreGauge({ score, size = 132 }: { score: number; size?: number }) {
  const clamped = Math.max(0, Math.min(100, Math.round(score)));
  const band = bandForScore(clamped);
  const stroke = 12;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = (clamped / 100) * c;

  return (
    <svg className="gauge__ring" width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img"
      aria-label={`Readiness score ${clamped} of 100`}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--bg-3)" strokeWidth={stroke} />
      <circle
        cx={size / 2} cy={size / 2} r={r} fill="none"
        stroke={BAND_COLOR[band]} strokeWidth={stroke} strokeLinecap="round"
        strokeDasharray={`${dash} ${c - dash}`}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
      <text x="50%" y="48%" textAnchor="middle" dominantBaseline="middle"
        style={{ fontFamily: 'var(--font-display)', fontSize: size * 0.3, fontWeight: 700, fill: 'var(--text)' }}>
        {clamped}
      </text>
      <text x="50%" y="66%" textAnchor="middle" dominantBaseline="middle"
        style={{ fontFamily: 'var(--font-mono)', fontSize: size * 0.09, fill: 'var(--text-3)' }}>
        / 100
      </text>
    </svg>
  );
}
